import gql from "graphql-tag";
const users = gql`
  query(
    $limit: Int
    $page: Int
    $status: String
    $hasEmployee: Boolean
    $query: String
    $departmentIds: [ID!]
  ) {
    users(
      hasEmployee: $hasEmployee
      query: $query
      filter: { status: $status, departmentIds: $departmentIds }
      paging: { limit: $limit, page: $page }
    ) {
      id
      fullname
      username
      email
    }
  }
`;

export default { users };
